import _ from "lodash";

/**
 * Created by swchen on 2017/6/6.
 */





const nop = function () {
    /* do nothing */
};

/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 * */

const lut = [];
for (let i = 0; i < 256; i += 1) {
    lut[i] = i < 16
        ? "0"
        : `${(i).toString(16)}`;
}
function uuid() {
    const d0 = Math.random() * 0XFFFFFFFF | 0;
    const d1 = Math.random() * 0XFFFFFFFF | 0;
    const d2 = Math.random() * 0XFFFFFFFF | 0;
    const d3 = Math.random() * 0XFFFFFFFF | 0;
    return `${lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff]}-${lut[d1 & 0xff]}${lut[d1 >> 8 & 0xff]}-${lut[d1 >> 16 & 0x0f | 0x40]}${lut[d1 >> 24 & 0xff]}-${lut[d2 & 0x3f | 0x80]}${lut[d2 >> 8 & 0xff]}-${lut[d2 >> 16 & 0xff]}${lut[d2 >> 24 & 0xff]}${lut[d3 & 0xff]}${lut[d3 >> 8 & 0xff]}${lut[d3 >> 16 & 0xff]}${lut[d3 >> 24 & 0xff]}`;
}


// https://nodejs.org/api/url.html#url_url_resolve_from_to
// url.resolve('/one/two/three', 'four');         // '/one/two/four'
// url.resolve('http://example.com/', '/one');    // 'http://example.com/one'
// url.resolve('http://example.com/one', '/two'); // 'http://example.com/two'


function urlresolve(/* ...urls */) {
    const len = arguments.length;
    if (len === 0) {
        throw new Error("resolveUrl requires at least one argument; got none.")
    }

    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/base
    let base = document.createElement("base");
    base.href = arguments[0];

    if (len === 1) {
        return base.href
    }

    const head = document.getElementsByTagName("head")[0];
    head.insertBefore(base, head.firstChild);

    let a = document.createElement("a");
    let resolved;

    for (let i = 1; i < len; i++) {
        a.href = arguments[i];
        resolved = a.href;
        base.href = resolved;
    }

    head.removeChild(base);

    return resolved
}


function mergeDeep(object1, object2) {


    if (object1 == null || object2 == null) {

        return object2;

    } else if (!_.isPlainObject(object1) || !_.isPlainObject(object2)) {

        return object2;

    } else if (object1 === object2) {

        return object2;

    } else {

        if ("_isMergeAtom" in object2) {

            const isMergeAtom = object2._isMergeAtom;
            delete object2._isMergeAtom;

            if (isMergeAtom) {
                return object2;
            }
        }


        let obj = {
            ...object1
        };
        _.forEach(object2, (value, key) => {

            if (key in object1) {

                obj[key] = mergeDeep(object1[key], value);

            } else {
                obj[key] = value;
            }
        });

        return obj;
    }
}


const getViewModel = (initState, type, ...childKeys) => {
    const resetType = `${type}-RESET`;

    return [
        (state = initState, action) => {
            switch (action.type) {
                case type: {
                    return mergeDeep(state, action.payload);
                }
                case resetType: {
                    if (action.key == null) {
                        return initState;
                    } else if (action.key in initState) {
                        return {
                            ...state,
                            [action.key]: initState[action.key],
                        };
                    } else {
                        return state;
                    }
                }
                default: {
                    return state;
                }
            }
        },

        payload => {
            return {
                type,
                payload,
            };
        },

        () => {
            return {
                type: resetType,
            };
        },

        ..._.flatMap(childKeys, it => [
            payload => {
                return {
                    type,
                    payload: {
                        [it]: payload,
                    },
                };
            },
            () => {
                return {
                    type: resetType,
                    key: it,
                };
            },
        ]),
    ];
};

// 测试异步请求状态改变用
const delay = (ms) => {
    return new Promise((resolve => {
        setTimeout(() => {
            resolve();
        }, ms);
    }))
}

const enumOf = arr => {
    const properties = _.keyBy(arr, it => it.key);
    const rst = _.mapValues(properties, it => it.key);
    rst.properties = properties;
    return rst;
};

const base64Decode = (s) => {
    const e = {}; let i; let b = 0; let c; let x; let l = 0; let a; let r = ""; const w = String.fromCharCode; const L = s.length;
    const A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0; i < 64; i++) { e[A.charAt(i)] = i; }
    for (x = 0; x < L; x++) {
        c = e[s.charAt(x)]; b = (b << 6) + c; l += 6;
        while (l >= 8) { ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a)); }
    }
    return r;
};


export default {
    nop,
    uuid,
    urlresolve,
    mergeDeep,
    getViewModel,
    enumOf,
    delay,
    base64Decode
};
